import { CalendarMonth as CalendarMonthIcon } from '@mui/icons-material';
import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { useAttend } from '../hooks';
import { useTicketFlowModals } from '../context';

const AttendButton = () => {
  const { ticketData, openAttendModal } = useTicketFlowModals();

  const { onAttend, isAttendCustomerLoading } = useAttend();

  const onAttendCustomer = () => {
    if (!ticketData) return;

    const { trackNumber, inboxId, sectorId } = ticketData;

    onAttend({
      totemSectorBody: {
        sectorId,
        trackNumber,
      },
      inboxId,
    });

    openAttendModal();
  };

  return (
    <GlobalButton
      variant={GlobalButtonVariant.primaryButton}
      disabled={isAttendCustomerLoading}
      action={onAttendCustomer}
    >
      <CalendarMonthIcon />
      Atender
    </GlobalButton>
  );
};

export default AttendButton;
